

import { db } from "../../config/firebase";
import { collection, addDoc, getDoc, query, where, getDocs, doc, deleteDoc, updateDoc } from 'firebase/firestore'


const createTodo = async (todoData, user) => {
    const colRef = collection(db, 'yapilacaklar');
    const docRef = await addDoc(colRef, { ...todoData, uid: user.uid })
    console.log(docRef);
    const docSnap = await getDoc(docRef)
    return { ...docSnap.data(), id: docSnap.id };
}

const getTodos = async (user) => {
    const colRef = collection(db, 'yapilacaklar');
    const q = query(colRef, where("uid", "==", user.uid))
    const querySnapshot = await getDocs(q);
    let dizi = [];
    querySnapshot.forEach((doc) => {
        dizi.push({ ...doc.data(), id: doc.id })
    });
    return dizi;
}

const deleteTodo = async (id) => {
    const docRef = doc(db, 'yapilacaklar', id);
    await deleteDoc(docRef);
    return id
}

const updateTodo = async (todoData, id) => {
    const docRef = doc(db, 'yapilacaklar', id);
    await updateDoc(docRef, todoData)
    const docSnap = await getDoc(docRef)
    return { ...docSnap.data(), id: docSnap.id };
}

const todoService = {
    createTodo,
    getTodos,
    deleteTodo,
    updateTodo,
}

export default todoService